import React from "react";
import { motion } from "framer-motion";
import RatingMeter from "./RatingMeter";

const ConversationPercentage = ({ wordPercentage, handleSaveAndGoHome }) => {
  const getConversationResult = (percentage) => {
    if (percentage < 50) {
      return <span style={{ color: "red" }}>low on empathy.</span>;
    } else if (percentage === 50) {
      return <span style={{ color: "grey" }}>neutral.</span>;
    } else if (percentage > 50) {
      return <span style={{ color: "green" }}>empathetic.</span>;
    }
  };
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.6 }}
      className="conversation-percentage max-w-3xl mx-auto flex flex-col items-center justify-center py-8  rounded-lg"
    >
      {wordPercentage !== null && wordPercentage !== undefined && (
      <h2 className="text-2xl font-semibold mb-6 flex items-center" style={{ color: "#212121" }}>
      {`This Conversation was`}&nbsp;{getConversationResult(wordPercentage)}
      </h2>
      )}

      <h2 className="text-2xl font-semibold mb-6 flex items-center" style={{ color: "#212121" }}>
        Conversation Match
      </h2>
      <p className="mb-8 md:text-lg sm:text-sm" style={{ color: "#757575" }}>
        Your conversation matches <span className="text-4xl font-bold">{wordPercentage ? Math.round(wordPercentage) : 0}%</span> with the recommended words.
      </p>
      <RatingMeter percentage={wordPercentage} />

       {/*
      <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="mt-10 bg-gradient-to-r from-indigo-500 to-indigo-600 hover:from-indigo-600 hover:to-indigo-700 text-white font-bold py-4 px-10 rounded-full shadow-lg transition-all duration-300 flex items-center"
                  onClick={handleSaveAndGoHome}
                >
                  Save and Go Home
                </motion.button>
        */}

    </motion.div>
  );
};

export default ConversationPercentage;
